import { Box } from "@material-ui/core";
import { Quote } from "../../../../api/Quote/Quote";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { SpecSheets } from "./SpecSheets";
// import { AssessmentModal } from "./AssessmentModal";

interface Props {
  quote: Quote;
  isSolar?: boolean;
  isGraphVisible?: boolean;
}
export const AssessmentComments = ({ quote, isSolar, isGraphVisible }: Props) => {
  const { isMoreThanSm, isMoreThanMd } = useBreakpoint();
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      paddingX={isMoreThanSm ? 0 : "24px"}
      justifyContent={"center"}
      pt={isMoreThanMd ? 0 : isSolar && isGraphVisible ? "60px" : "30px"}
    >
      <Box
        fontSize={isMoreThanSm ? "16px" : "14px"}
        textAlign={isMoreThanSm ? "left" : "center"}
        mb={"35px"}
        fontWeight={400}
        color={isMoreThanSm ? "#4b5462" : "rgba(17, 21, 33, 0.65)"}
      >
        Following the technical survey, your assessor conducted the notes below:
      </Box>

      <Box
        maxWidth={"769px"}
        width={"100%"}
        fontSize={"14px"}
        fontWeight={400}
        color={"rgba(17, 21, 33, 0.65)"}
        px={isMoreThanMd || !isMoreThanSm ? 0 : "51px"}
      >
        {quote.customerText?.split("\n").map((item, idx) => (
          <Box key={idx} marginBottom={"14px"}>
            {item}
          </Box>
        ))}
        <SpecSheets quote={quote} />
      </Box>
    </Box>
  );
};
